export default __webpack_public_path__ + "static/media/about-selected.6c8ac56b.svg";